
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2088',
  depVersions: {
  "customer-portal-app": "static-1.2088",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.458",
  "data-fetching-client": "static-1.9611",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25162",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5531",
  "hs-test-utils": "static-1.7950",
  "hub-http": "static-1.6158",
  "hub-http-shared-msw-handlers": "static-1.9810",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18038",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11398",
  "I18n": "static-7.1610",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6406",
  "payment-link-components": "static-1.23339",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6931",
  "quartz-core": "static-1.6150",
  "react": "static-7.184",
  "react-colorpicker": "static-2.10147",
  "react-dlb": "static-1.77",
  "react-utils": "static-2.5295",
  "rich-text-lib": "static-1.19716",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17893",
  "ui-components-test-utils": "static-1.5536",
  "UIComponents": "static-3.8345",
  "foundations-assets": "static-1.4790",
  "foundations-components": "static-1.7803",
  "foundations-theming": "static-1.4352",
  "foundations-theming-specialty": "static-1.2068",
  "framer-motion": "static-1.70",
  "history": "static-4.47",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.770",
  "quartz-config": "static-1.709",
  "quartz-routing": "static-1.361",
  "quick-fetch": "static-1.3868",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-feature-id-1324-marker-timings.4",
  "react-router-dom": "static-5.26",
  "rpc-client-utils": "static-1.4582",
  "sanitize-text": "static-1.8081",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.53",
  "ui-addon-draggable": "static-3.4706",
  "ui-addon-react-router-dom": "static-1.9481",
  "usage-tracker": "static-1.7273",
  "usage-tracker-anonymous": "static-1.5690",
  "usage-tracker-core": "static-1.7123",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3355",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3208",
  "quartz-webpack": "static-1.3155",
  "bend-plugin-quartz-routing": "static-1.9",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "customer-data-objects": "static-1.7598",
  "frontend-preferences-client": "static-1.7863",
  "laboratory-lib": "static-3.7095",
  "onboarding-scopes": "static-1.6401",
  "ui-addon-opt": "static-4.8317",
  "HeadJS": "static-2.740",
  "hs-test-utils-bend-plugin": "static-1.3061",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.35",
  "ts-schema": "static-1.4029",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7650",
  "cssUtils": "static-1.778",
  "customer-data-ui-utilities": "static-1.9763",
  "HubStyle": "static-2.11706",
  "knowledge-content-types": "static-1.8479",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.606",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.485",
  "ui-addon-emoji-picker": "static-1.9824",
  "ui-addon-i18n": "static-1.11087",
  "ui-business-units-lib": "static-1.8981",
  "ui-shepherd-react": "static-3.10085",
  "video-components-external": "static-1.11048",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4261",
  "commerce-tours-lib": "static-1.5972",
  "customer-data-properties": "static-1.51307",
  "getting-started-shared-tasks": "static-1.18304",
  "growth-onboarding-reliability": "static-1.5020",
  "onboarding-tours": "static-1.16473",
  "reference-resolvers-lite": "static-1.8029",
  "sales-checkout-service-client": "static-1.3577",
  "ui-addon-iframeable": "static-1.8989",
  "user-context": "static-1.5037",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.826",
  "hubspotter-http": "static-1.4603",
  "icons": "static-2.643",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.606",
  "quartz-head": "static-1.596",
  "quartz-test": "static-1.606",
  "quartz-tracking": "static-1.310",
  "ui-fonts": "static-1.660",
  "usage-tracker-container": "static-1.7263",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9366",
  "data-token-picker": "static-1.16287",
  "FileManagerLib": "static-1.39062",
  "property-translator": "static-1.5339",
  "atom": "static-1.5008",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5765",
  "salesImages": "static-1.523",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5286",
  "react-select-plus": "static-1.103",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1138",
  "bend-plugin-foundations-components": "static-1.4072",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "trellis-assets": "static-1.1622",
  "bend-plugin-foundations-theming": "static-1.2835",
  "foundations-theming-base": "static-1.3337",
  "stylex": "static-1.31",
  "interframe": "static-3.4699",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5687",
  "chirp-fetch": "static-1.1820",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4409",
  "react-flip-move": "static-1.68",
  "bender-build-tools": "static-1.3093",
  "inbound-db-properties-service-client": "static-1.3793",
  "superstore": "static-1.4705",
  "feedback-loader": "static-1.29177",
  "ai-components-ui-library": "static-1.8770",
  "ui-addon-video-player": "static-1.8634",
  "ui-coaching-tips": "static-1.28352",
  "sassPrefix": "static-1.154",
  "react-dnd-compat": "static-1.4556",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2432",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8107",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4587",
  "content-media-composition-data-lib": "static-1.12027",
  "content-media-compositions": "static-2.16034",
  "idb-keyval": "static-1.42",
  "immer": "static-1.33",
  "immerable": "static-1.4090",
  "magpie-lib": "static-1.5519",
  "magpie-types": "static-1.4979",
  "media-bridge-lib": "static-1.18810",
  "video-data-lib": "static-1.34706",
  "commerce-products-lib": "static-1.9275",
  "crm-message-bus": "static-1.42796",
  "growth-data-modal": "static-1.5322",
  "hubspot-apollo-client": "static-1.4815",
  "onboarding-tours-client": "static-1.4687",
  "calling-global-api": "static-1.64261",
  "calling-internal-common": "static-1.31239",
  "calling-lifecycle-internal": "static-1.65643",
  "calling-lifecycle-messages": "static-1.57937",
  "conditional-properties-service-client": "static-1.3748",
  "crm-links": "static-1.6216",
  "customer-data-objects-ui-components": "static-1.12959",
  "customer-data-properties-shared-msw-handlers": "static-1.9137",
  "customer-data-property-utils": "static-1.8019",
  "external-options-client-types": "static-1.4110",
  "file-manager-components": "static-1.23422",
  "framework-data-schema-resolvers": "static-1.6813",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.79",
  "inbound-db-meta-service-client": "static-1.3542",
  "inbounddb-objects-service-types": "static-1.4175",
  "meetings-icalendar-utils-lib": "static-1.567",
  "multi-currency-client-types": "static-1.3643",
  "object-builder-ui-client": "static-1.48508",
  "pipeline-validation-client-types": "static-1.3917",
  "property-value-citations": "static-1.1921",
  "pulse": "static-1.489",
  "smart-property-lib": "static-1.6603",
  "tiered-pricing": "static-1.1070",
  "ui-addon-form-validation": "static-1.10927",
  "growth-onboarding-confetti": "static-1.3006",
  "growth-onboarding-next-action-utils": "static-1.1712",
  "navigation-components": "static-1.17800",
  "onboarding-tours-utils": "static-1.539",
  "ui-shepherd-tracker": "static-1.7466",
  "ui-universal-auth": "static-1.8894",
  "batch-promise": "static-1.1489",
  "navigation-messaging": "static-1.7127",
  "getting-started-shared-tasks-store": "static-1.17422",
  "hubspotter-http-shared-msw-handlers": "static-1.9808",
  "usage-tracker-session-replay": "static-1.4959",
  "audio-components": "static-1.5814",
  "FileManagerCore": "static-1.38921",
  "FileManagerImages": "static-1.36573",
  "video-components": "static-1.13051",
  "foundations-components-legacy": "static-1.828",
  "purchase-motions-api": "static-1.5768",
  "self-service-api": "static-1.10182",
  "signup-constants": "static-1.18730",
  "signup-ui-url-generator": "static-2.7973",
  "trials-service-types": "static-1.3839",
  "usage-tracker-public": "static-1.7084",
  "chatspot-core": "static-1.20971",
  "ContentUtils": "static-1.68158",
  "copilot-toolkit": "static-1.10944",
  "growth-onboarding-feedback-components": "static-1.6520",
  "reactive-lib": "static-1.659",
  "simple-logging-lib": "static-1.2987",
  "commerce-permissions": "static-1.703",
  "customer-data-tracking": "static-1.6822",
  "products-iframe-lib": "static-1.7735",
  "products-ui-components-shared-msw-handlers": "static-1.10192",
  "onboarding-data-sync-lib": "static-1.1846",
  "hubspot-apollo-cache": "static-1.274",
  "calling-error-reporting": "static-1.31245",
  "shared-worker-versioning": "static-1.10974",
  "calling-usage-tracker": "static-1.6478",
  "voice-sms-access-library": "static-1.716",
  "conversations-skeleton-state": "static-1.7187",
  "location-customization-utils-lib": "static-1.9035",
  "crm-pipelines-api-client-types": "static-1.4094",
  "framework-builder-read-service-client": "static-1.3961",
  "framework-data-schema-quick-fetch": "static-1.6718",
  "persist-promise": "static-1.3646",
  "directed-graph": "static-1.874",
  "event-emitter": "static-1.885",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.88",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9893",
  "fsm": "static-1.3671",
  "policy-lib": "static-1.6712",
  "react-tinymce": "static-1.55049",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9956",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54175",
  "tinymce-plugins": "static-1.57289",
  "tinymce-themes": "static-1.56145",
  "growth-onboarding-next-action-components": "static-1.1740",
  "user-context-client": "static-1.4548",
  "nest": "static-1.160",
  "unified-auth-core-lib": "static-1.689",
  "amplitude-session-replay-browser": "static-1.58",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4468",
  "video-embed": "static-1.35540",
  "content-icons-ui": "static-1.2211",
  "social-insights-client-types": "static-1.21882",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4747",
  "integrations-lib": "static-1.15894",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4200",
  "InboxConnectUtils": "static-4.14618",
  "calling-orchestration-schema": "static-1.35493",
  "crm-record-cards-service-types": "static-1.3562",
  "highcharts": "static-8.102",
  "trellis-story-utils": "static-1.4454",
  "storybook-react": "static-1.31",
  "hub-http-contrib": "static-1.2978",
  "tinymce-data": "static-1.40260",
  "ui-addon-sales-email": "static-1.5148",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12316",
  "layout-dnd-utils": "static-1.11291",
  "react-codemirror": "static-1.10560",
  "ui-brand-identity-lib": "static-1.14949",
  "NamespacedHubStyle": "static-2.9015",
  "outpost": "static-1.4126",
  "flux-actions": "static-1.329",
  "integrations-error-boundary-lib": "static-1.13309",
  "integrations-tracking-lib": "static-1.5534",
  "native-integrations-shared-strings": "static-1.7722",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10310",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.408",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68233",
  "layout-data-lib": "static-1.9616",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2946",
  "google-sheets-integration-lib": "static-1.36",
  "microsoft-drive-integration-lib": "static-1.136",
  "advanced-menus-core": "static-1.15025",
  "advanced-menus-lib": "static-1.11980",
  "ExportDialog": "static-6.10329",
  "ui-memberships-settings-lib": "static-1.33855",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15024",
  "simple-menus-lib": "static-1.16541"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2088",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.458",
  "data-fetching-client": "/data-fetching-client/static-1.9611",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25162",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5531",
  "hs-test-utils": "/hs-test-utils/static-1.7950",
  "hub-http": "/hub-http/static-1.6158",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9810",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18038",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11398",
  "I18n": "/I18n/static-7.1610",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6406",
  "payment-link-components": "/payment-link-components/static-1.23339",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6931",
  "quartz-core": "/quartz-core/static-1.6150",
  "react": "/react/static-7.184",
  "react-colorpicker": "/react-colorpicker/static-2.10147",
  "react-dlb": "/react-dlb/static-1.77",
  "react-utils": "/react-utils/static-2.5295",
  "rich-text-lib": "/rich-text-lib/static-1.19716",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17893",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5536",
  "UIComponents": "/UIComponents/static-3.8345",
  "foundations-assets": "/foundations-assets/static-1.4790",
  "foundations-components": "/foundations-components/static-1.7803",
  "foundations-theming": "/foundations-theming/static-1.4352",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2068",
  "framer-motion": "/framer-motion/static-1.70",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.770",
  "quartz-config": "/quartz-config/static-1.709",
  "quartz-routing": "/quartz-routing/static-1.361",
  "quick-fetch": "/quick-fetch/static-1.3868",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1324-marker-timings.4",
  "react-router-dom": "/react-router-dom/static-5.26",
  "rpc-client-utils": "/rpc-client-utils/static-1.4582",
  "sanitize-text": "/sanitize-text/static-1.8081",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.53",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4706",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9481",
  "usage-tracker": "/usage-tracker/static-1.7273",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5690",
  "usage-tracker-core": "/usage-tracker-core/static-1.7123",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3355",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3208",
  "quartz-webpack": "/quartz-webpack/static-1.3155",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.9",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "customer-data-objects": "/customer-data-objects/static-1.7598",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7863",
  "laboratory-lib": "/laboratory-lib/static-3.7095",
  "onboarding-scopes": "/onboarding-scopes/static-1.6401",
  "ui-addon-opt": "/ui-addon-opt/static-4.8317",
  "HeadJS": "/HeadJS/static-2.740",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3061",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.35",
  "ts-schema": "/ts-schema/static-1.4029",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7650",
  "cssUtils": "/cssUtils/static-1.778",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9763",
  "HubStyle": "/HubStyle/static-2.11706",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.606",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9824",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11087",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8981",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10085",
  "video-components-external": "/video-components-external/static-1.11048",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4261",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5972",
  "customer-data-properties": "/customer-data-properties/static-1.51307",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18304",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5020",
  "onboarding-tours": "/onboarding-tours/static-1.16473",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8029",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3577",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8989",
  "user-context": "/user-context/static-1.5037",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "hubspotter-http": "/hubspotter-http/static-1.4603",
  "icons": "/icons/static-2.643",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.606",
  "quartz-head": "/quartz-head/static-1.596",
  "quartz-test": "/quartz-test/static-1.606",
  "quartz-tracking": "/quartz-tracking/static-1.310",
  "ui-fonts": "/ui-fonts/static-1.660",
  "usage-tracker-container": "/usage-tracker-container/static-1.7263",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9366",
  "data-token-picker": "/data-token-picker/static-1.16287",
  "FileManagerLib": "/FileManagerLib/static-1.39062",
  "property-translator": "/property-translator/static-1.5339",
  "atom": "/atom/static-1.5008",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5765",
  "salesImages": "/salesImages/static-1.523",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5286",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1138",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4072",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.1622",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2835",
  "foundations-theming-base": "/foundations-theming-base/static-1.3337",
  "stylex": "/stylex/static-1.31",
  "interframe": "/interframe/static-3.4699",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5687",
  "chirp-fetch": "/chirp-fetch/static-1.1820",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4409",
  "react-flip-move": "/react-flip-move/static-1.68",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3793",
  "superstore": "/superstore/static-1.4705",
  "feedback-loader": "/feedback-loader/static-1.29177",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8770",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8634",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28352",
  "sassPrefix": "/sassPrefix/static-1.154",
  "react-dnd-compat": "/react-dnd-compat/static-1.4556",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2432",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8107",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4587",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12027",
  "content-media-compositions": "/content-media-compositions/static-2.16034",
  "idb-keyval": "/idb-keyval/static-1.42",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4090",
  "magpie-lib": "/magpie-lib/static-1.5519",
  "magpie-types": "/magpie-types/static-1.4979",
  "media-bridge-lib": "/media-bridge-lib/static-1.18810",
  "video-data-lib": "/video-data-lib/static-1.34706",
  "commerce-products-lib": "/commerce-products-lib/static-1.9275",
  "crm-message-bus": "/crm-message-bus/static-1.42796",
  "growth-data-modal": "/growth-data-modal/static-1.5322",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4815",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4687",
  "calling-global-api": "/calling-global-api/static-1.64261",
  "calling-internal-common": "/calling-internal-common/static-1.31239",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65643",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57937",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3748",
  "crm-links": "/crm-links/static-1.6216",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12959",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9137",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8019",
  "external-options-client-types": "/external-options-client-types/static-1.4110",
  "file-manager-components": "/file-manager-components/static-1.23422",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6813",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.79",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3542",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4175",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.567",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3643",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48508",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3917",
  "property-value-citations": "/property-value-citations/static-1.1921",
  "pulse": "/pulse/static-1.489",
  "smart-property-lib": "/smart-property-lib/static-1.6603",
  "tiered-pricing": "/tiered-pricing/static-1.1070",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10927",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3006",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1712",
  "navigation-components": "/navigation-components/static-1.17800",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.539",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7466",
  "ui-universal-auth": "/ui-universal-auth/static-1.8894",
  "batch-promise": "/batch-promise/static-1.1489",
  "navigation-messaging": "/navigation-messaging/static-1.7127",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17422",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9808",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4959",
  "audio-components": "/audio-components/static-1.5814",
  "FileManagerCore": "/FileManagerCore/static-1.38921",
  "FileManagerImages": "/FileManagerImages/static-1.36573",
  "video-components": "/video-components/static-1.13051",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.828",
  "purchase-motions-api": "/purchase-motions-api/static-1.5768",
  "self-service-api": "/self-service-api/static-1.10182",
  "signup-constants": "/signup-constants/static-1.18730",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7973",
  "trials-service-types": "/trials-service-types/static-1.3839",
  "usage-tracker-public": "/usage-tracker-public/static-1.7084",
  "chatspot-core": "/chatspot-core/static-1.20971",
  "ContentUtils": "/ContentUtils/static-1.68158",
  "copilot-toolkit": "/copilot-toolkit/static-1.10944",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6520",
  "reactive-lib": "/reactive-lib/static-1.659",
  "simple-logging-lib": "/simple-logging-lib/static-1.2987",
  "commerce-permissions": "/commerce-permissions/static-1.703",
  "customer-data-tracking": "/customer-data-tracking/static-1.6822",
  "products-iframe-lib": "/products-iframe-lib/static-1.7735",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10192",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1846",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.274",
  "calling-error-reporting": "/calling-error-reporting/static-1.31245",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10974",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6478",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.716",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7187",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9035",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4094",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3961",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6718",
  "persist-promise": "/persist-promise/static-1.3646",
  "directed-graph": "/directed-graph/static-1.874",
  "event-emitter": "/event-emitter/static-1.885",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.88",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9893",
  "fsm": "/fsm/static-1.3671",
  "policy-lib": "/policy-lib/static-1.6712",
  "react-tinymce": "/react-tinymce/static-1.55049",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9956",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54175",
  "tinymce-plugins": "/tinymce-plugins/static-1.57289",
  "tinymce-themes": "/tinymce-themes/static-1.56145",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1740",
  "user-context-client": "/user-context-client/static-1.4548",
  "nest": "/nest/static-1.160",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.689",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4468",
  "video-embed": "/video-embed/static-1.35540",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "social-insights-client-types": "/social-insights-client-types/static-1.21882",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4747",
  "integrations-lib": "/integrations-lib/static-1.15894",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4200",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14618",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35493",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3562",
  "highcharts": "/highcharts/static-8.102",
  "trellis-story-utils": "/trellis-story-utils/static-1.4454",
  "storybook-react": "/storybook-react/static-1.31",
  "hub-http-contrib": "/hub-http-contrib/static-1.2978",
  "tinymce-data": "/tinymce-data/static-1.40260",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5148",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12316",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11291",
  "react-codemirror": "/react-codemirror/static-1.10560",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14949",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9015",
  "outpost": "/outpost/static-1.4126",
  "flux-actions": "/flux-actions/static-1.329",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13309",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5534",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7722",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10310",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.408",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68233",
  "layout-data-lib": "/layout-data-lib/static-1.9616",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2946",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.36",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.136",
  "advanced-menus-core": "/advanced-menus-core/static-1.15025",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11980",
  "ExportDialog": "/ExportDialog/static-6.10329",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33855",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15024",
  "simple-menus-lib": "/simple-menus-lib/static-1.16541"
}
};
